import { Switch } from '@mui/material';
import React from "react";
import {useTranslation} from "react-i18next";
import Stack from "@mui/material/Stack";
import {CustomStyleSwitch, CustomStyleSwitchContainer} from "./Styles";
import CustomInputLabel from "./CustomInputLabel";
import {Box} from "@mui/system";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @Description Switch with dynamic content
 * @param String id: Identifier for the Switch (required)
 * @param String name: Name for the Switch (optional)
 * @param Boolean disabled: Enable/disable Switch (optional)
 * @param String transLeft: Text for the left label (required)
 * @param String transRight: Text for the right label (required)
 * @param Boolean checked: Is checked (required)
 * @param Event onChange: onChange trigger in the Switch (required)
 * @returns {JSX.Element}
 */
export const CustomAntSwitch = ({id, title, name, disabled=false, transLeft, transRight, checked, onChange}) => {
    const { t } = useTranslation();

    return <Box sx={CustomStyleSwitchContainer}>
        {title && <CustomInputLabel trans={title} classes={"switch-title"}/>}
        <Stack direction="row" spacing={1} className={"switch-container"} >
            <CustomInputLabel trans={t(transLeft)}/>
            <Switch
                sx={CustomStyleSwitch}
                id={id}
                name={name}
                disabled={disabled}
                checked={checked}
                onChange={onChange}
                color="primary"
            />
            <CustomInputLabel trans={t(transRight)}/>
        </Stack>
    </Box>
}
